import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'

const CalendarButton = ({ label, text, iconName, onClick }) => (
  <div className='schedule-msg-modal-calendar-btn'>
    {label ? <label>{label}</label> : null}
    <button type='button' onClick={onClick}>
      <p className='text-ellipsis'>{text}</p>
      <figure>
        <img src={getStaticImage(`/icons/orange-brand/${iconName}.svg`)} alt='Calendar' />
      </figure>
    </button>
  </div>
)

export default CalendarButton
